<template>
	<div>
        <div>
            <div>
                <Table border @on-selection-change="batchChange($event)" :columns="columns" :data="msg.data"></Table>
            </div>
        </div>
	</div>
</template>
<script>
	export default{
		props:['msg'],
		data(){
			return{
                columns:[               //批量设置答案弹出层table表头
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },{
                        title: '表头信息',
                        key: 'td'
                    }
                ],
            }
		},
		methods:{
            batchChange(e){
                this.msg.init=e;
            },
        }
	}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/template/split/one.vue